import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import useMobile from '../../hooks/useMobile'
import { getEventType } from '../../types/EventTypes'
import CustomTabs from '../input/CustomTabs'

const SURFACE_TYPES = ['Hard', 'Clay', 'Indoor', 'Sand', 'Grass', 'Other']
const SKILL_LEVELS = ['Beginner', 'Intermediate', 'Intermediate high', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']

const SelectionEditModal = ({
  isOpen,
  title,
  label,
  choices,
  onClose,
  onSave,
  initialValue,
  isLoading,
}: {
  title: string
  label: string
  choices: string[]
  isOpen: boolean
  onClose: () => void
  onSave: (v: string) => void
  initialValue: string
  isLoading: boolean
}) => {
  const isMobile = useMobile(600)

  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p="0">
          <Text variant="title" fontSize="2xl" fontWeight="500" mb="20px">
            {title}
          </Text>

          <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
            {label}
          </Text>
          <CustomTabs
            name="selection"
            value={choices.indexOf(value)}
            onChange={(v) => setValue(choices[v])}
            choices={choices}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            variant="heavy"
            size="sm"
            isLoading={isLoading}
            onClick={() => {
              const finalValue =
                label == 'Event Type' || label == 'Secondary Type'
                  ? getEventType(value)
                  : label == 'Surface'
                  ? SURFACE_TYPES.indexOf(value)
                  : label == 'Skill level'
                  ? SKILL_LEVELS.indexOf(value)
                  : choices.indexOf(value)
              onSave(typeof finalValue === 'string' ? finalValue : finalValue.toString())
            }}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default SelectionEditModal
